import { render } from "./PrestamosList.vue?vue&type=template&id=d20b21fa&scoped=true"
import script from "./PrestamosList.vue?vue&type=script&lang=js"
export * from "./PrestamosList.vue?vue&type=script&lang=js"

import "./PrestamosList.vue?vue&type=style&index=0&id=d20b21fa&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d20b21fa"]])

export default __exports__